import React, { createContext, useState, FC, PropsWithChildren } from 'react';
import invariant from 'tiny-invariant';
import Modal from '../components/Modal';

interface ModalContextInterface {
  openModal: (modal: Modal) => void;
  closeModal: () => void;
  modal: Modal | undefined;
}

const ModalContext = createContext<ModalContextInterface>({} as ModalContextInterface);

export const ModalProvider: FC<PropsWithChildren> = ({ children }) => {
  const [modal, setModal] = useState<Modal>();

  const openModal = (modal: Modal): void => setModal(modal);
  const closeModal = (): void => setModal(undefined);

  const value = {
    openModal,
    closeModal,
    modal,
  };

  return (
    <ModalContext.Provider value={value}>
      {modal && <Modal modal={modal} />}
      {children}
    </ModalContext.Provider>
  );
};

export const useModalContext = (): ModalContextInterface => {
  const context = React.useContext(ModalContext);
  invariant(
    context && Object.prototype.hasOwnProperty.call(context, 'openModal'),
    'useModalContext must be used within a ModalProvider'
  );
  return context;
};
